import type {FormInstance} from 'antd';
import type {NamePath} from 'antd/es/form/interface';

import type {LciFormTabKey} from '../constants/lciFormValues';

export type LciSubTabId = 'prod' | 'a1' | 'a2' | 'a3' | 'a4' | 'b' | 'c';

export const LCI_SUBTAB_ORDER: LciSubTabId[] = [
  'prod',
  'a1',
  'a2',
  'a3',
  'a4',
  'b',
  'c'
];

export const LCI_SUBTAB_TO_FIELD_PREFIX: Record<LciSubTabId, LciFormTabKey> = {
  prod: 'production',
  a1: 'a1',
  a2: 'a2',
  a3: 'a3',
  a4: 'a4',
  b: 'b',
  c: 'c'
};

const fieldMatchesPrefix = (name: NamePath, prefix: string): boolean => {
  if (Array.isArray(name)) {
    return name[0] === prefix;
  }

  return name === prefix;
};

/** Validates only Form.Item fields currently registered under the given prefix. */
export const validateMountedFieldsForPrefix = async (
  form: FormInstance,
  prefix: string
): Promise<void> => {
  const registeredNames = form
    .getFieldsError()
    .map(({name}) => name)
    .filter((name) => fieldMatchesPrefix(name, prefix));

  if (registeredNames.length === 0) {
    await form.validateFields([[prefix]]);

    return;
  }

  await form.validateFields(registeredNames);
};

export const getNextLciSubTab = (tab: LciSubTabId): LciSubTabId | null => {
  const index = LCI_SUBTAB_ORDER.indexOf(tab);

  if (index < 0 || index >= LCI_SUBTAB_ORDER.length - 1) {
    return null;
  }

  return LCI_SUBTAB_ORDER[index + 1];
};

export const isLastLciSubTab = (tab: LciSubTabId): boolean =>
  tab === LCI_SUBTAB_ORDER[LCI_SUBTAB_ORDER.length - 1];
